import { Phone, Mail, Facebook, ArrowRight } from "lucide-react";
import { LOGO, NAV_LINKS, SERVICES, CITIES, PHONE, PHONE_HREF, EMAIL, FACEBOOK_URL } from "@/lib/site-data";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-black border-t border-white/10 overflow-hidden pb-24 md:pb-0">
      <div className="max-w-7xl mx-auto px-4 md:px-8 pt-20 pb-8 border-b border-white/10 flex flex-wrap items-center justify-between gap-8">
        <div>
          <h2 className="font-display text-3xl md:text-4xl font-semibold tracking-tight">
            Ready to protect what you built?
          </h2>
          <p className="mt-2 text-gray-400">Free estimates across Kentucky. No pressure, no obligation.</p>
        </div>
        <a
          href="#estimate"
          data-testid="footer-estimate-btn"
          className="inline-flex items-center gap-2 rounded-md bg-[#0066FF] px-8 py-4 font-display text-sm font-semibold tracking-widest text-white transition-[background-color,box-shadow,color] duration-300 hover:bg-[#00E5FF] hover:text-black hover:shadow-[0_0_35px_rgba(0,229,255,0.55)]"
        >
          GET A FREE ESTIMATE <ArrowRight size={16} />
        </a>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <img src={LOGO} alt="Phillips Waterproofing & Concrete" className="h-16 w-auto mb-5" />
          <p className="text-sm text-gray-400 leading-relaxed max-w-xs">
            Professional waterproofing, foundation repair, and concrete services for homes and
            businesses throughout Kentucky.
          </p>
          <a
            href={FACEBOOK_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-facebook-link"
            className="mt-5 inline-flex items-center gap-2 rounded-md border border-white/15 px-4 py-2.5 text-sm font-bold text-gray-300 hover:border-cyan-400 hover:text-cyan-400 transition-colors duration-200"
          >
            <Facebook size={16} /> Follow on Facebook
          </a>
        </div>

        <div>
          <h3 className="text-xs uppercase tracking-[0.25em] font-bold text-cyan-400 mb-5">Navigate</h3>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.label}>
                <a href={l.href} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`} className="text-sm text-gray-400 hover:text-white transition-colors duration-200 link-underline">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-xs uppercase tracking-[0.25em] font-bold text-cyan-400 mb-5">Services</h3>
          <ul className="space-y-3">
            {SERVICES.map((s) => (
              <li key={s.id} className="text-sm text-gray-400">{s.title}</li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-xs uppercase tracking-[0.25em] font-bold text-cyan-400 mb-5">Contact</h3>
          <a href={PHONE_HREF} data-testid="footer-phone-link" className="flex items-center gap-2.5 text-sm text-gray-300 hover:text-cyan-400 transition-colors duration-200 font-bold">
            <Phone size={16} className="text-cyan-400" /> {PHONE}
          </a>
          <a href={`mailto:${EMAIL}`} data-testid="footer-email-link" className="mt-3 flex items-center gap-2.5 text-sm text-gray-400 hover:text-cyan-400 transition-colors duration-200">
            <Mail size={16} className="text-cyan-400" /> {EMAIL}
          </a>
          <h3 className="text-xs uppercase tracking-[0.25em] font-bold text-cyan-400 mt-8 mb-4">Service Areas</h3>
          <p className="text-sm text-gray-500 leading-relaxed">
            {CITIES.slice(0, 10).join(" · ")} &amp; surrounding communities
          </p>
        </div>
      </div>

      <div className="relative">
        <p className="pointer-events-none select-none text-center font-display font-bold uppercase leading-none text-[17vw] text-white/[0.035] -mb-[3vw]">
          Phillips
        </p>
      </div>

      <div className="relative border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-gray-500">
          <p>© 2026 Phillips Waterproofing &amp; Concrete. All rights reserved.</p>
          <p>Licensed &amp; Insured · Lifetime warranty available on qualifying systems</p>
        </div>
      </div>
    </footer>
  );
}
